import { createContext, useContext } from 'react';
/** Context for evaluating and updating color scheme settings. */
export const ColorSchemeContext = createContext(null);
ColorSchemeContext.displayName = 'ColorSchemeContext';
export function useColorScheme() {
    return useContext(ColorSchemeContext);
}
//# sourceMappingURL=useColorScheme.js.map